// import { Component, OnInit } from '@angular/core';



import { Component, OnInit, ViewChild, ViewChildren, QueryList } from '@angular/core';
import { Lifecycle } from 'src/app/_helpers/Lifecycle/Lifecycle.class';
import { MatPaginator, MatTableDataSource, MatSort, MatDialog } from '@angular/material';

import { FormBuilder, Validators, FormGroup } from '@angular/forms';
import { $ModalManagerService } from '../../../../_helpers/Modals/ModalManager.service';
import { formatDate } from '@angular/common';
import { Constants } from '../../../../_utils/Constants';
import { $DBManagerService } from '../../../../_helpers/DB/DBManager.service';
import { APIImportPreferenceService } from '../../_services/import-preference/API-import-preference';
import { APIDndRegistrationDetails } from '../../_services/dnd-registration-details/API-dnd-registration-details';

import { map } from 'rxjs/operators';

import { APIObserverService } from '../../_observerServices/API-Observer';


import { OperatorWiseCountComponent } from '../operator-wise-count/operator-wise-count.component';




export interface Element {
  operator: string;
  count: number;

}
@Component({
  selector: 'app-search-dnd-preference-obv',
  templateUrl: './search-dnd-preference-obv.component.html',
  styleUrls: ['./search-dnd-preference-obv.component.css']
})
export class SearchDndPreferenceObvComponent implements OnInit {

  public subscriberdetails: any;
  dndPreference: FormGroup;
  cmode: any;
  time: any;
  ctgr: any;
  day: any;
  reqno: any;
  cts: any;
  uts: any;
  mobilenumber: any;
  sts: any;
  displayedColumns2: string[] = ['cmode', 'time', 'ctgr', 'day', 'reqno', 'cts'];
  dataSource: MatTableDataSource<any>;
  noRecord: any;
  displayTable: boolean = false;
  displayedColumns: string[] = ['operator', 'count'];

  ELEMENT_DATA: Element[] = [
    { operator: 'Tata', count: null },
    { operator: 'Airtel', count: null },
    { operator: 'Vodafone', count: null },
    { operator: 'BSNL', count: null },
    { operator: 'ML', count: null },
    { operator: 'QL', count: null },
    { operator: 'Jio', count: null },
    { operator: 'VI', count: null },
    { operator: 'Vodafone', count: null },
    { operator: 'RCOM', count: null }
  ]
  operatorTable = new MatTableDataSource(this.ELEMENT_DATA);

  modeOfCommunicationData = new Map([[11, 'Voice Call'],
  [13, 'Auto Dailer Call with Pre-recorded'], [14, 'Auto Dailer Call with Live Agent'], [15, 'Robo-calls']]);

  // For Time Bands
  tbCheck: boolean = false;
  timeBandsData = new Map([[21, '00:00 Hrs to 06:00 Hrs'], [22, '06:00 Hrs to 08:00 Hrs'], [23, '08:00 Hrs to 10:00 Hrs'],
  [24, '10:00 Hrs to 12:00 Hrs'], [25, '12:00 Hrs to 14:00 Hrs'], [26, '14:00 Hrs to 16:00 Hrs'],
  [27, '16:00 Hrs to 18:00 Hrs'], [28, '18:00 Hrs to 21:00 Hrs'], [29, '21: 00 Hrs to 24:00 Hrs']]);
  serviceAreaCodes = {
    "1": "Andhra Pradesh", //Andhra Pradesh
    "2": "Assam", //Assam
    "3": "Bihar", //Bihar
    "4": "Chennai", //Chennai
    "5": "Delhi", //Delhi
    "6": "Gujarat", //Gujarat
    "7": "Haryana", //Haryana
    "8": "Himachal Pradesh", //Himachal Prade
    "9": "Jammu & Kashmir", //Jammu & Kashmi
    "10": "Karnataka",//Karnataka
    "11": "Kerala",//Kerala
    "12": "Kolkata",//Kolkata
    "13": "MadhyaPradesh",//MadhyaPradesh
    "14": "Maharastra",//Maharastra
    "15": "Mumbai",//Mumbai
    "16": "North East",//North East
    "17": "Orissa",//Orissa
    "18": "Punjab",//Punjab
    "19": "Rajasthan",//Rajasthan
    "20": "Tamilnadu",//Tamilnadu
    "21": "UP East",//UP East
    "22": "UP West",//UP West
    "23": "West Bengal",//West Bengal
  }
  //For Day Type
  mcckeys: any[];
  timekeys: any[];
  dayskeys: any[];
  ctgrkeys: any[];
  mccString = [];
  timeString = [];
  daysString = [];
  ctgrString = [];
  serviceArea: any;
  serviceProvider: any;

  daysData = new Map([[31, 'Mon'], [32, 'Tue'], [33, 'Wed'], [34, 'Thu'], [35, 'Fri'],
  [36, 'Sat'], [37, 'Sun'], [38, 'Public Holiday & National Holiday']]);

  //For category
  categoryData = new Map([[1, 'Banking / Insurance / Financial products / credit cards'],
  [2, 'Real Estate'], [3, 'Education'],
  [4, 'Health'], [5, 'Consumer Goods and Automobiles'], [6, 'Communication / Broadcasting / Entertainment / IT'],
  [7, 'Tourism and Leisure'], [8, 'Food and Beverages'], [0, 'Fully Blocked'], [50, 'Block Only Promotions']]);


  @ViewChildren(MatPaginator) paginator = new QueryList<MatPaginator>();
  @ViewChild('t1Sort') t1Sort: MatSort;
  constructor(private fb: FormBuilder,

    private $modal: $ModalManagerService,
    private obv: APIObserverService,

    private db: $DBManagerService,
    private _call: APIDndRegistrationDetails,
    private dialog: MatDialog,

  ) { }

  ngOnInit() {
    this.dndPreference = this.fb.group({

      number: ['', [Validators.required, Validators.pattern("[0-9]{10}")]],
      cmode: ['', Validators.required],
      time: ['', Validators.required],
      ctgr: ['', Validators.required],

      reqno: ['', Validators.required],
      day: ['', Validators.required],
      msisdn: ['', Validators.required],
    })
    // this.getCount();
  }
  get f() { return this.dndPreference.controls; }


  getCount() {
    this.obv.ObserverPreferenceCount('TA').subscribe(r => {
      this.ELEMENT_DATA[0]['count'] = r.result
    })
    this.obv.ObserverPreferenceCount('AI').subscribe(r => {
      this.ELEMENT_DATA[1]['count'] = r.result
    })
    this.obv.ObserverPreferenceCount('VO').subscribe(r => {
      this.ELEMENT_DATA[2]['count'] = r.result
    })
    this.obv.ObserverPreferenceCount('BL').subscribe(r => {
      this.ELEMENT_DATA[3]['count'] = r.result
    })
    this.obv.ObserverPreferenceCount('ML').subscribe(r => {
      this.ELEMENT_DATA[4]['count'] = r.result
    })
    this.obv.ObserverPreferenceCount('QL').subscribe(r => {
      this.ELEMENT_DATA[5]['count'] = r.result
    })
    this.obv.ObserverPreferenceCount('JI').subscribe(r => {
      this.ELEMENT_DATA[6]['count'] = r.result
    })
    this.obv.ObserverPreferenceCount('VI').subscribe(r => {
      this.ELEMENT_DATA[7]['count'] = r.result
    })
    this.obv.ObserverPreferenceCount('VM').subscribe(r => {
      this.ELEMENT_DATA[8]['count'] = r.result
    })
    this.obv.ObserverPreferenceCount('RC').subscribe(r => {
      this.ELEMENT_DATA[9]['count'] = r.result
    })

  }
  onSubmit() {
    if (this.dndPreference.controls["number"].invalid) {
      return;
    }
    this.mccString = [];
    this.timeString = [];
    this.daysString = [];
    this.ctgrString = [];

    this.mobilenumber = this.dndPreference.get('number').value;
    console.log("This mobilenumber ", this.mobilenumber)

    if (this.mobilenumber) {

      this.obv.getPreferencesForObserver(this.mobilenumber)
        .subscribe(r => {

          this.subscriberdetails = r;
          console.log("this.subscriberdetails ___________", this.subscriberdetails);
          console.log("this.subscriberdetails ________,", this.subscriberdetails.preferences);
          console.log("r.data,", r.data);



          if (this.subscriberdetails.preferences) {
            this.onChangeDataSource(this.subscriberdetails.preferences)
            this.displayTable = true;
          }
          else {
            this.$modal.errorModal({
              title: 'DND Preference',
              msg: 'Data Not Found'
            });
            this.displayTable = false;
          }



        });
    }
  }
  onChangeDataSource(value) {
    console.log("value", value)
    this.dataSource = new MatTableDataSource(value);
    // this.dataSource.paginator =this.paginator.toArray()[0];
    this.dataSource.sort = this.t1Sort;
    this.dataSource.data = value;
    this.cmode = this.dataSource.data['cmode'];
    this.time = this.dataSource.data['time'];
    this.ctgr = this.dataSource.data['ctgr'];
    this.day = this.dataSource.data['day'];
    this.reqno = this.dataSource.data['reqno'];
    this.cts = this.dataSource.data['cts'];
    this.uts = this.dataSource.data['uts'];

    if (this.dataSource.data['sts'] == "A")
      this.sts = "Active"
    else if (this.dataSource.data['sts'] == "D")
      this.sts = "Deactive"
    else if (this.dataSource.data['sts'] == "T")
      this.sts = "Terminated"
    else
      this.sts = ""


    this.mcckeys = this.cmode.split(',');
    this.mcckeys = this.mcckeys.filter(function (entry) { return entry.trim() != ''; });

    this.timekeys = this.time.split(',');
    this.timekeys = this.timekeys.filter(function (entry) { return entry.trim() != ''; });

    this.ctgrkeys = this.ctgr.split(',');
    this.ctgrkeys = this.ctgrkeys.filter(function (entry) { return entry.trim() != ''; });


    this.dayskeys = this.day.split(',');
    this.dayskeys = this.dayskeys.filter(function (entry) { return entry.trim() != ''; });


    if (this.mcckeys.length == 0) {
      this.mccString[0] = "No mode is selected"
    }
    else {
      for (let i = 0; i < this.mcckeys.length; i++) {
        this.mccString[i] = this.modeOfCommunicationData.get(this.mcckeys[i] * 1)
      }
    }



    if (this.timekeys.length == 0) {
      this.timeString[0] = "No time is selected"
    }
    else
      for (let i = 0; i < this.timekeys.length; i++) {
        {
          this.timeString[i] = this.timeBandsData.get(this.timekeys[i] * 1)
        }
      }
    if (this.dayskeys.length == 0) {
      this.daysString[0] = "No Day is selected"
    }
    else {

      for (let i = 0; i < this.dayskeys.length; i++) {

        this.daysString[i] = this.daysData.get(this.dayskeys[i] * 1)
      }
    }

    if (this.ctgrkeys.length == 0) {
      this.ctgrString[0] = "No Category is selected"
    }

    else {
      //if (this.ctgrkeys.length == 1) {
        if (this.ctgr == "90") {
          this.ctgrString[0] = "Deactivated the preferences"
        }
		
     // }
      else {
        for (let i = 0; i < this.ctgrkeys.length; i++) {


          this.ctgrString[i] = this.categoryData.get(this.ctgrkeys[i] * 1)
        }
      }
    }

    this.serviceArea = this.serviceAreaCodes[this.dataSource.data['srvac']]
    if(this.dataSource.data['svcprv'] == 'TA'){
      this.serviceProvider = "Tata" 
    }
    if(this.dataSource.data['svcprv'] == 'AI'){
      this.serviceProvider = "Airtel"
    }
    if(this.dataSource.data['svcprv'] == 'JI'){
      this.serviceProvider = "JIO"
    }
    if(this.dataSource.data['svcprv'] == 'ID'){
      this.serviceProvider = "Idea"
    }
    if(this.dataSource.data['svcprv'] == 'ML'){
      this.serviceProvider = "MTNL"
    }
    if(this.dataSource.data['svcprv'] == 'BL'){
      this.serviceProvider = "BSNL"
    }
    if(this.dataSource.data['svcprv'] == 'VO'){
      this.serviceProvider = "Vodafone";
    }
    if(this.dataSource.data['svcprv'] == 'VM'){
      this.serviceProvider = "VMIPL"
    }
    if(this.dataSource.data['svcprv'] == 'QL'){
      this.serviceProvider = "QTL"
    }

    this.dndPreference.controls['reqno'].setValue(this.reqno);





    this.noRecord = this.dataSource.connect().pipe(map(data => data.length === 0));
  }
  openDialog() {
    const dialogRef = this.dialog.open(OperatorWiseCountComponent, {
      panelClass: 'custom-dialog-container'
    })
  }

}

 